import React from 'react';
import {
  Globe,
  Search,
  Mail,
  TrendingUp,
  Users,
  Code,
  Brain,
  Bot
} from 'lucide-react';

const Services: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950">
      {/* Header */}
      <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Services Catalog</h1>
            <p className="text-gray-600 dark:text-gray-300">Manage service offerings and pricing</p>
          </div>
        </div>
      </div>

      {/* Empty State */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <div className="flex justify-center gap-4 mb-6 flex-wrap">
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Globe className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Search className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <TrendingUp className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Users className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Mail className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Code className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Brain className="w-7 h-7 text-gray-400" />
            </div>
            <div className="w-14 h-14 bg-gray-200 dark:bg-gray-800 rounded-xl flex items-center justify-center">
              <Bot className="w-7 h-7 text-gray-400" />
            </div>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Services Catalog Coming Soon</h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
            Service offerings, pricing tiers, and catalog management will be configured here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Services;
